import React, { useState } from 'react'
import {
    Form,
    FloatingLabel,
    Col,
    Row,
    Button,
    Nav,
} from 'react-bootstrap';

const DEFAULT_FILTER = {
    trustee_number: "",
    county: ""
};

export default function SearchBar({ onSearch, onClear }) {

    const [fields, setFields] = useState(DEFAULT_FILTER);

    const setField = (type, e) => {
        setFields((pre) => ({
            ...pre,
            [type]: e.target.value
        }));
    }

    const handleSearch = (e) => {
        e.preventDefault()
        onSearch(fields);
    }

    const handleReset = () => {
        setFields(DEFAULT_FILTER);
        onClear(DEFAULT_FILTER);
    }

    return (
        <Form className="trustee-search-form" onSubmit={handleSearch}>
            <Row className="g-2 mb-2">
                <Col xs={6}>
                    <FloatingLabel
                        controlId="TrusteeNumber"
                        label="Trustee Number"
                    >
                        <Form.Control
                            type="text"
                            placeholder="Trustee Number"
                            value={fields.trustee_number}
                            onChange={(e) => setField('trustee_number', e)}
                        />
                    </FloatingLabel>
                </Col>
                <Col xs={6}>
                    <FloatingLabel
                        controlId="County"
                        label="County"
                    >
                        <Form.Control
                            type="text"
                            placeholder="County"
                            onChange={(e) => setField('county', e)}
                            value={fields.county}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            <Nav>
                <Button onClick={handleReset}   variant="secondary" type="button">
                    Clear
                </Button>
                <Button variant="primary" type="submit" className="mx-2">
                    Search
                </Button>
            </Nav>
        </Form>
    )
}
